import React from 'react'
import { useSnackbar } from 'notistack'
import { Box, CircularProgress } from '@mui/material'
import { useParams } from 'react-router'

import { useActiveVideoVisit } from '~/shared/hooks/activeVideoVisit'
import { SessionProvider } from './Zoom/SessionProvider'
import { useInitAppointment } from './useInitAppointment'
import { logger } from '~/shared/lib/logger'

const ZOOM_NOTIFICATION_KEY = 'ZOOM_NOTIFICATION_KEY'

const handleError = (
  clearActiveVideoVisit: () => void,
  enqueueSnackbar: ReturnType<typeof useSnackbar>['enqueueSnackbar'],
  error: string,
) => {
  logger.warn('Error while handling appointment entry. Leaving appointment.', { error })
  enqueueSnackbar(error, {
    variant: 'error',
    persist: false,
    key: ZOOM_NOTIFICATION_KEY,
  })
  clearActiveVideoVisit()
}

export const AppointmentEntry: React.FC<{ modal: boolean; id?: string }> = props => {
  const { id: routeAppointmentId } = useParams()
  const { activeVideoVisitId, clearActiveVideoVisit } = useActiveVideoVisit()
  const { enqueueSnackbar } = useSnackbar()
  const appointmentId = activeVideoVisitId ?? routeAppointmentId
  const init = useInitAppointment(props.id || appointmentId)
  const session = init.result?.session

  // This component should only ever be mounted if there is an appointmentId
  if (init.loading)
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    )

  if (init.error || !appointmentId || !session || !init.result) {
    handleError(
      clearActiveVideoVisit,
      enqueueSnackbar,
      'Failed to load appointment, please reload and try again',
    )
    return <></>
  }

  return (
    <SessionProvider
      modal={props.modal}
      sessionName={session.session_name}
      token={session.token}
      appointment={init.result.appointment}
    />
  )
}
